/**
 * @format
 */

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Filter from 'img/ArrowsDownUp.svg';
import Search from 'img/Search.svg';
import { Layout } from 'features/layout';
import LeaderboardContainer from 'features/leaderboard/containers/LeaderboardContainer';
import WeeklyLeaderboardContainer from 'features/leaderboard/containers/WeeklyLeaderboardContainer';
import { AgentLeaderboardFilterInput } from 'features/leaderboard/types/leaderboard.types';

interface LeaderboardPageProps {}

const LeaderboardPage: React.FC<LeaderboardPageProps> = () => {
  const [activeTab, setActiveTab] = useState<'agent' | 'weekly'>('agent');
  const [filter, setFilter] = useState<AgentLeaderboardFilterInput>({});
  const [searchTerm, setSearchTerm] = useState('');

  // Get user details and date range from Redux
  const userDetails = useSelector((state: any) => state.user?.userData);
  console.log('User Details in LeaderboardPage:', userDetails);
  const startDate = useSelector((state: any) => state.dropDown?.startDate);
  const endDate = useSelector((state: any) => state.dropDown?.endDate);

  // Update filter based on user role and dates
  React.useEffect(() => {
    const newFilter: AgentLeaderboardFilterInput = {};

    // Add dates if available
    if (startDate) {
      newFilter.startDate = startDate;
    }
    if (endDate) {
      newFilter.endDate = endDate;
    }

    // Add role-based filters
    if (userDetails) {
      const userRole = userDetails.role;
      console.log('User Details:', userDetails);
      console.log('User Role:', userRole);
      console.log('Office ID:', userDetails.officeId);

      // For agent or admin roles, add officeId
      if (userRole === 'agent' || userRole === 'admin') {
        if (userDetails.officeId) {
          newFilter.officeId = userDetails.officeId;
          console.log('Adding officeId to filter:', userDetails.officeId);
        } else {
          console.log('No officeId found for agent/admin user');
        }
      }
      // For root_user, only pass dates (already added above)
      // No additional filter needed
    }

    console.log('Final filter:', newFilter);
    setFilter(newFilter);
  }, [startDate, endDate, userDetails]);

  const handleTabChange = (tab: 'agent' | 'weekly') => {
    setActiveTab(tab);
  };

  return (
    <Layout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '28px',
        }}>
        {/* Tab Navigation */}
        <div className='campaign-header-containger'>
          <div className='leaderboard-tab-wrapper'>
            <span
              onClick={() => handleTabChange('agent')}
              className={activeTab === 'agent' ? 'active' : ''}>
              Agent Leaderboard
            </span>
            <span
              onClick={() => handleTabChange('weekly')}
              className={activeTab === 'weekly' ? 'active' : ''}>
              Weekly Leaderboard
            </span>
          </div>
        </div>

        {/* Agent Leaderboard Tab */}
        {activeTab === 'agent' && (
          <div>
            {/* Filter and Search Section */}
            <div style={{ marginBottom: '20px' }}>
              <div className='filter-container'>
                <div className='filter'>
                  <img src={Filter} alt='filter icon' />
                  <span>Filter By Division</span>
                </div>

                <div className='search'>
                  <img src={Search} alt='search icon' />
                  <input
                    placeholder='Search agent...'
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Podium and Leaderboard Table (single API call) */}
            <LeaderboardContainer filter={filter} />
          </div>
        )}

        {/* Weekly Leaderboard Tab */}
        {activeTab === 'weekly' && (
          <div>
            <WeeklyLeaderboardContainer filter={filter} />
          </div>
        )}
      </div>
    </Layout>
  );
};

export default LeaderboardPage;
